import { FETCH_NEWS, FETCH_SINGLE_NEWS } from "../constants/actionTypes";

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_NEWS:
      return [...state, ...action.payload];
    // break;
    case FETCH_SINGLE_NEWS:
      let index = state.findIndex(state => {
        return state.id === action.payload[0].id;
      });
      if (index >= 0) {
        return state;
      } else {
        return [...state, ...action.payload];
      }
    // break;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/newsReducer.js